<template lang="pug">
.services-search(:class="{ 'is-mobile': isMobile }")
  b-input(
    icon="search"
    :value="filters.query"
    placeholder="Search for services..."
    @input="set($event, 'query')"
    @keyup.native.enter="apply"
    rounded
  )
  a.reset-button(@click="reset" v-if="filters.query")
    b-icon(icon="times-circle" size="is-small" pack="fas")
</template>

<script>
import { mapGetters } from 'vuex';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

export default {
  name: 'services-search',
  computed: {
    ...mapGetters({
      filters: getterTypes.GET_SERVICES_FILTERS,
    }),
    isMobile() {
      return window.innerWidth <= 769;
    },
  },
  methods: {
    apply() {
      this.$store.commit(mutationTypes.SET_SERVICES_FILTER, {
        key: 'displayQuery',
        val: true,
      });
      this.$store.commit(mutationTypes.SET_SERVICES_REFRESH, true);
    },
    reset() {
      this.$store.commit(mutationTypes.SET_SERVICES_FILTER, {
        key: 'query',
        val: null,
      });
      this.$store.commit(mutationTypes.SET_SERVICES_FILTER, {
        key: 'displayQuery',
        val: false,
      });
      this.$store.commit(mutationTypes.SET_SERVICES_REFRESH, true);
    },
    set(val, key) {
      if (val) {
        this.$store.commit(mutationTypes.SET_SERVICES_FILTER, {
          key,
          val,
        });
      } else {
        this.$store.commit(mutationTypes.SET_SERVICES_FILTER, {
          key,
          val: null,
        });
        this.$store.commit(mutationTypes.SET_SERVICES_FILTER, {
          key: 'displayQuery',
          val: false,
        });
        this.$store.commit(mutationTypes.SET_SERVICES_REFRESH, true);
      }
    },
  },
};
</script>

<style lang="scss">
.services-search {
  // margin-bottom: 1.25rem;
  //
  // input {
  //   border: none;
  //   border-radius: 0;
  // }
  position: relative;
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  .reset-button {
    position: absolute;
    top: 29px;
    right: 36px;
    color: $grey-light;
  }
  &.is-mobile {
    input {
      padding: 0.35rem;
    }
  }
  // &:not(.is-mobile) {
  //   input {
  //     height: 56px;
  //   }
  // }
}
</style>

<style theme="cwo" lang="scss">
.services-search {
  .input {
    font-family: $body-font !important;
    background: $white-ter;
    border: none;
  }
}
</style>
